import React from "react";
import { createRoot } from "react-dom/client";
import Website from "./Website";
import { DASHBOARD_URL, HOME_ANCHORS, PORTAL_URL } from "./links";

/**
 * Older bookmarks, verification links and checkout returns used the root page with a hash
 * (#sign-in, #invitation/…, #wall). Those still go to the right app; the site's own anchors stay.
 */
function redirectLegacyRoute() {
  if (location.pathname !== "/" && location.pathname !== "/index.html") return false;
  const hash = location.hash,
    query = new URLSearchParams(location.search);
  if (hash === "#wall") {
    location.replace(PORTAL_URL + location.search);
    return true;
  }
  const ownAnchor = HOME_ANCHORS.includes(decodeURIComponent(hash.slice(1)));
  if ((hash && hash !== "#" && hash !== "#main" && !ownAnchor) || query.has("invitation") || query.has("checkout")) {
    location.replace(DASHBOARD_URL + location.search + hash);
    return true;
  }
  return false;
}
if (!redirectLegacyRoute()) {
  window.addEventListener("hashchange", redirectLegacyRoute);
  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Website />
    </React.StrictMode>,
  );
}
